import { timestampToDate } from '@spotify/confidence-core-react';
import type { PlanningDataFragment } from '@spotify/confidence-graphql';

export type PlanningDatePeriods = {
  plannedStartDate: Date | null;
  plannedEndDate: Date | null;
  actualStartDate: Date | null;
  actualEndDate: Date | null;
};

export const getPlanningDates = (
  planning?: Pick<PlanningDataFragment, 'planned' | 'actual'> | null,
): PlanningDatePeriods => ({
  plannedStartDate: timestampToDate(planning?.planned?.startTime),
  plannedEndDate: timestampToDate(planning?.planned?.endTime),
  actualStartDate: timestampToDate(planning?.actual?.startTime),
  actualEndDate: timestampToDate(planning?.actual?.endTime),
});
